import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import YouTube from "react-youtube";

function YouTubePlayer({ videoId }) {
  return (
    <Box height={0} pb="56.25%" position="relative" bg="lightGrey">
      <YouTube videoId={videoId} className="youtube-embed" />
    </Box>
  );
}

export default YouTubePlayer;

YouTubePlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
};
